import angular from 'angular';
import _remove from 'lodash/remove';
import _sortedIndexBy from 'lodash/sortedIndexBy';
import _toLower from 'lodash/toLower';
/**
 * @desc  EmployeeService class.
 */
var EmployeeService = /** @class */ (function () {
    function EmployeeService($rootScope, $q, $log, $http) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$q = $q;
        this.$log = $log;
        this.$http = $http;
        this.unassignedEmployees = [];
        this.employees = [];
        this.activeEmployees = [];
        this.roles = [];
        this.workPeriods = [];
        this.employeesLoading = false;
        this.$rootScope.$on('scr.select', function () {
            _this.unassignedEmployees.splice(0, _this.unassignedEmployees.length);
            _this.employees.splice(0, _this.employees.length);
            _this.activeEmployees.splice(0, _this.activeEmployees.length);
            _this.workPeriods.splice(0, _this.workPeriods.length);
        });
    }
    EmployeeService.prototype.getUnassignedEmployees = function (id, fromServer) {
        var _this = this;
        if (id === void 0) { id = 0; }
        if (fromServer === void 0) { fromServer = false; }
        var scrId = this.$rootScope.me.schoolCommonRoomId;
        if (this.unassignedEmployees.length > 0 && !fromServer) {
            return this.$q.resolve(this.unassignedEmployees);
        }
        if (id > 0) {
            scrId = id;
        }
        return this.$http({
            method: 'GET',
            url: "/SCR/schoolCommonRoom/".concat(scrId, "/unassignedEmployee")
        }).then(function (result) {
            result.data.unassignedEmployees.forEach(function (employee) {
                employee.role = 0;
                return employee;
            });
            _this.unassignedEmployees = result.data.unassignedEmployees;
            return _this.unassignedEmployees;
        }, function (err) { return _this.$q.reject(err); });
    };
    EmployeeService.prototype.getRoles = function (fromServer) {
        var _this = this;
        if (fromServer === void 0) { fromServer = false; }
        if (this.roles.length > 0 && !fromServer) {
            return this.$q.resolve(this.roles);
        }
        return this.$http({
            method: 'GET',
            url: '/SCR/role'
        }).then(function (result) {
            _this.roles = result.data.roles;
            return _this.roles;
        }, function (err) { return _this.$q.reject(err); });
    };
    EmployeeService.prototype.getSchoolCommonRoomEmployees = function (id, fromServer) {
        var _this = this;
        if (id === void 0) { id = 0; }
        if (fromServer === void 0) { fromServer = false; }
        var deferred = this.$q.defer();
        if (this.employees.length > 0 && !fromServer) {
            deferred.resolve(this.employees);
            return deferred.promise;
        }
        if (this.employeesLoading) {
            return deferred.promise;
        }
        var schoolCommonRoomId = this.$rootScope.me.schoolCommonRoomId;
        if (id > 0) {
            schoolCommonRoomId = id;
        }
        this.$http({
            method: 'GET',
            url: "/SCR/schoolCommonRoom/".concat(schoolCommonRoomId, "/employee")
        }).then(function (result) {
            _this.employees = result.data.employees.map(function (employee) {
                employee.fullNameWithAccount = employee.fullName + ' (' + employee.accountType + ')';
                return employee;
            });
            deferred.resolve(_this.employees);
        }, function (err) { return deferred.reject(err); });
        this.employeesLoading = true;
        deferred.promise.finally(function () {
            _this.employeesLoading = false;
        });
        return deferred.promise;
    };
    EmployeeService.prototype.getEmployeesWithoutSupply = function () {
        return this.getSchoolCommonRoomEmployees()
            .then(function (result) { return result.filter(function (employee) { return employee.role !== 5; }); });
    };
    EmployeeService.prototype.getSchoolCommonRoomActiveEmployees = function (id, fromServer) {
        var _this = this;
        if (id === void 0) { id = 0; }
        if (fromServer === void 0) { fromServer = false; }
        if (this.activeEmployees.length > 0 && !fromServer) {
            return this.$q.resolve(this.activeEmployees);
        }
        var schoolCommonRoomId = this.$rootScope.me.schoolCommonRoomId;
        if (id > 0) {
            schoolCommonRoomId = id;
        }
        return this.$http({
            method: 'GET',
            url: "/SCR/schoolCommonRoom/".concat(schoolCommonRoomId, "/activeEmployees")
        }).then(function (result) {
            _this.activeEmployees = result.data.employees;
            return _this.activeEmployees;
        }, function (err) { return _this.$q.reject(err); });
    };
    EmployeeService.prototype.addEmployee = function (employee, id) {
        var _this = this;
        if (id === void 0) { id = 0; }
        var copyEmployee = {};
        angular.copy(employee, copyEmployee);
        var schoolCommonRoomId = this.$rootScope.me.schoolCommonRoomId;
        if (id > 0) {
            schoolCommonRoomId = id;
        }
        return this.$http({
            method: 'POST',
            url: "/SCR/schoolCommonRoom/".concat(schoolCommonRoomId, "/employee"),
            data: { employee: employee }
        }).then(function (result) {
            copyEmployee.id = result.data.id;
            // @ts-ignore
            _this.employees.unshift(copyEmployee);
            _this.unassignedEmployees = _this.unassignedEmployees.filter(function (item) { return item.userId !== copyEmployee.userId; });
            return copyEmployee;
        }, function (err) { return _this.$q.reject(err); });
    };
    EmployeeService.prototype.editEmployee = function (employee, id) {
        var _this = this;
        if (id === void 0) { id = 0; }
        var copyEmployee = {};
        angular.copy(employee, copyEmployee);
        var schoolCommonRoomId = this.$rootScope.me.schoolCommonRoomId;
        if (id > 0) {
            schoolCommonRoomId = id;
        }
        return this.$http({
            method: 'PUT',
            url: "/SCR/schoolCommonRoom/".concat(schoolCommonRoomId, "/employee/").concat(employee.id),
            data: { employee: employee }
        }).then(function () {
            return copyEmployee;
        }, function (err) { return _this.$q.reject(err); });
    };
    EmployeeService.prototype.deleteEmployee = function (employee, id) {
        var _this = this;
        var copyEmployee = {};
        angular.copy(employee, copyEmployee);
        var schoolCommonRoomId = this.$rootScope.me.schoolCommonRoomId;
        if (id > 0) {
            schoolCommonRoomId = id;
        }
        return this.$http({
            method: 'DELETE',
            url: "/SCR/schoolCommonRoom/".concat(schoolCommonRoomId, "/employee/").concat(employee.id)
        }).then(function () {
            // @ts-ignore
            _remove(_this.employees, function (item) { return item.id === copyEmployee.id; });
            _this.unassignedEmployees.splice(_sortedIndexBy(_this.unassignedEmployees, copyEmployee, function (item) { return _toLower(item.fullName); }), 0, copyEmployee);
            return copyEmployee;
        }, function (err) { return _this.$q.reject(err); });
    };
    EmployeeService.prototype.addWorkPeriod = function (employeeId, workPeriod) {
        var _this = this;
        return this.$http({
            method: 'POST',
            url: "/SCR/employee/".concat(employeeId, "/workPeriods"),
            data: { workPeriod: workPeriod }
        }).then(function (result) { return result; }, function (err) { return _this.$q.reject(err); });
    };
    EmployeeService.prototype.editWorkPeriod = function (employeeId, workPeriod) {
        var _this = this;
        return this.$http({
            method: 'PUT',
            url: "/SCR/employee/".concat(employeeId, "/workPeriods/").concat(workPeriod.id),
            data: workPeriod
        }).then(function (result) { return result.data.MessagePL; }, function (err) { return _this.$q.reject(err); });
    };
    EmployeeService.prototype.deleteWorkPeriod = function (employeeId, workPeriodId) {
        var _this = this;
        return this.$http({
            method: 'DELETE',
            url: "/SCR/employee/".concat(employeeId, "/workPeriods/").concat(workPeriodId)
        }).then(function (result) { return result.data.MessagePL; }, function (err) { return _this.$q.reject(err); });
    };
    EmployeeService.prototype.addWorkDay = function (employeeId, workDay) {
        var _this = this;
        return this.$http({
            method: 'POST',
            url: "/SCR/employee/".concat(employeeId, "/workDays"),
            data: { workDay: workDay }
        }).then(function (result) { return result; }, function (err) { return _this.$q.reject(err); });
    };
    EmployeeService.prototype.editWorkDay = function (employeeId, workDay) {
        var _this = this;
        return this.$http({
            method: 'PUT',
            url: "/SCR/employee/".concat(employeeId, "/workDays/").concat(workDay.id),
            data: { workDay: workDay }
        }).then(function (result) { return result.data.MessagePL; }, function (err) { return _this.$q.reject(err); });
    };
    EmployeeService.prototype.deleteWorkDay = function (employeeId, workDayId) {
        var _this = this;
        return this.$http({
            method: 'DELETE',
            url: "/SCR/employee/".concat(employeeId, "/workDays/").concat(workDayId)
        }).then(function (result) { return result.data.MessagePL; }, function (err) { return _this.$q.reject(err); });
    };
    EmployeeService.prototype.getWorkPeriods = function (fromServer, monthNumber) {
        var _this = this;
        if (fromServer === void 0) { fromServer = false; }
        if (monthNumber === void 0) { monthNumber = 0; }
        if (this.workPeriods.length > 0 && !fromServer) {
            return this.$q.resolve(this.workPeriods);
        }
        var url = "/SCR/schoolCommonRoom/".concat(this.$rootScope.me.schoolCommonRoomId, "/workDays");
        if (monthNumber > 0 && monthNumber < 13) {
            url += '?month=' + monthNumber;
        }
        return this.$http({
            method: 'GET',
            url: url
        }).then(function (result) {
            _this.workPeriods = [];
            result.data.workDays.forEach(function (workDay) {
                workDay.start = workDay.start.replace(' ', 'T');
                workDay.end = workDay.end.replace(' ', 'T');
                _this.workPeriods.push(workDay);
            });
            return _this.workPeriods;
        }, function (err) { return _this.$q.reject(err); });
    };
    EmployeeService.prototype.getWorkDay = function (employeeId, workDayId) {
        var _this = this;
        if (employeeId === void 0) { employeeId = 0; }
        if (workDayId === void 0) { workDayId = 0; }
        return this.$http({
            method: 'GET',
            url: "/SCR/employee/".concat(employeeId, "/workDays/").concat(workDayId)
        }).then(function (result) { return result.data.workDay[0]; }, function (err) { return _this.$q.reject(err); });
    };
    EmployeeService.prototype.getWorkPeriod = function (employeeId, workPeriodId) {
        var _this = this;
        if (employeeId === void 0) { employeeId = 0; }
        if (workPeriodId === void 0) { workPeriodId = 0; }
        return this.$http({
            method: 'GET',
            url: "/SCR/employee/".concat(employeeId, "/workPeriods/").concat(workPeriodId)
        }).then(function (result) {
            var data = result.data;
            var workingDays = [];
            var counter = 1;
            for (var key in data.workingDays) {
                if (Object.prototype.hasOwnProperty.call(data.workingDays, key)) {
                    if (data.workingDays[key]) {
                        workingDays.push(counter);
                    }
                    counter += 1;
                }
            }
            data.workingDays = workingDays;
            return data;
        }, function (err) { return _this.$q.reject(err); });
    };
    EmployeeService.prototype.getCreatedWaitingStudents = function (options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        return this.$http({
            method: 'GET',
            url: "/SCR/employee/".concat(this.$rootScope.me.employeeId, "/createdWaitingStudents"),
            params: { groupId: options.groupId },
            ignoreLoadingBar: !options.showLoaderSpinner
        }).then(function (result) { return result.data.waitingStudents; }, function (err) { return _this.$q.reject(err); });
    };
    EmployeeService.prototype.deleteWaitingStudent = function (employeeId, waitingStudentsIds) {
        var _this = this;
        waitingStudentsIds = waitingStudentsIds.map(function (id) { return Number(id); });
        return this.$http({
            method: 'PUT',
            url: "/SCR/employee/".concat(employeeId, "/waitingStudents"),
            data: {
                identifiers: waitingStudentsIds,
                isRead: true
            }
        }).then(function (result) { return result; }, function (err) { return _this.$q.reject(err); });
    };
    /**
     * Constructor of the class.
     *
     * @param {$rootScope} $rootScope
     * @param {$q} $q
     * @param {$log}  $log
     * @param {$http} $http
     */
    EmployeeService.$inject = ['$rootScope', '$q', '$log', '$http'];
    return EmployeeService;
}());
export default EmployeeService;
